import styled from "styled-components";
import { Dropdown, Button } from "antd";
import { Menu } from "antd";
// import { useTheme } from "@mui/material/styles";

const CustomDropdown = ({ items, style, icon, children, ...rest }) => {
  //   const theme = useTheme();
  // Define the styled component for dropdown overlay
  const StyledMenu = styled(Menu)`
    && {
      color: black !important;
      //   border: 1px solid black !important;
      margin-right: 15px !important;
      .ant-dropdown-menu-item {
        background-color: transparent;
        // font-weight: 500;
        color: black;
      }

      .ant-dropdown-menu-item:hover {
        background-color: transparent !important;
        color: #1bb560 !important;
      }
    }
  `;
  return (
    <Dropdown overlay={<StyledMenu items={items} />} trigger={["click"]}>
      <Button
        style={{
          border: "none",
          height: "33px",
          textTransform: "capitalize",
          display: "flex",
          alignItems: "center",
          gap: "5px",
          borderRadius: "4px",
          ...style,
        }}
      >
        {children}
        {icon}
      </Button>
    </Dropdown>
  );
};

export default CustomDropdown;
